module.exports = new __parcel__URL__("insight-object-schema-header-skeleton.tpl.79a3b4bf.svg").toString();